import type { HubProjectDatapool } from '@robovision/hub'


interface DatapoolParams {
  artifactId?: string
  createdAt: Date
  description: string
  exampleDefinitionId: string
  id: string
  immutable: boolean
  logicalType?: string
  name: string
  projectId: string
  sourceJobId?: string
}

export class Datapool {
  artifactId?: string
  createdAt: Date
  description: string
  exampleDefinitionId: string
  id: string
  immutable: boolean
  logicalType?: string
  projectId: string
  name: string
  sourceJobId?: string

  public constructor (params: DatapoolParams) {
    this.artifactId = params.artifactId
    this.createdAt = params.createdAt
    this.description = params.description
    this.exampleDefinitionId = params.exampleDefinitionId
    this.id = params.id
    this.immutable = params.immutable
    this.logicalType = params.logicalType
    this.name = params.name
    this.projectId = params.projectId
    this.sourceJobId = params.sourceJobId
  }

  public static fromResponse (data: HubProjectDatapool) {
    return new Datapool({
      artifactId: data.artifactId,
      createdAt: new Date(data.createdAt),
      description: data.description,
      exampleDefinitionId: data.exampleDefinitionId,
      id: data.id,
      immutable: false,
      logicalType: data.logicalType,
      name: data.name,
      projectId: data.projectId,
      sourceJobId: data.sourceJobId,
    })
  }
}
